import { render } from "./IconInformation.vue?vue&type=template&id=2de7de86&scoped=true"
const script = {}

import "./IconInformation.vue?vue&type=style&index=0&id=2de7de86&scoped=true&lang=css"

import exportComponent from "../../../../Bocco/Rental/WebApp/Bocco/Rental/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de7de86"]])

export default __exports__